import _ from "lodash";
import Box from "./components/box";
import Btn from "./components/btn";
import Input from "./components/input";
import Spinner from "./components/spinner";
import h from "./core/createElement"
import popupAlerts from "./core/popupAlerts";
import { log_in } from "./service/api";
import { switchable_element } from "./utils";


export default function Login({ }) {
    const
        shared = {},
        fields_name = ['username', 'password'],
        loading = switchable_element(<Spinner black={false} />);

    const
        login = async () => {
            try {
                if (is_invalid_fields()) return;

                loading.show();

                const body = _.chain(fields_name).map(e => ([[e], shared[e].value])).fromPairs().value()

                await log_in(body);

                loading.hide();
            } catch (e) {
                loading.hide();
            }
        },
        is_invalid_fields = () => {
            let error = false;

            for (let i of fields_name) {
                const input = shared[i];

                if (input.value == "") {
                    input.invalid(true);
                    error = true;
                };
            };
            if (error) popupAlerts.warning("Preencha corretamente os campos!");
            return error;
        },
        go_to_next_input = (next_one) => {
            return (evt) => {
                if (evt.key !== 'Enter') return
                evt.preventDefault();
                shared[next_one].element.focus();
            }
        };

    return (
        <section class="full-size flex align-center justify-center full-container">
            <Box >
                <section class="full-size flex-column login-form">
                    <Input title="Usuário" shared={shared} name="username" onKeydown={go_to_next_input('password')} />
                    <Input title="Senha" shared={shared} name="password" type="password" onKeydown={go_to_next_input('send_btn')} />

                    <section class="flex btn-sign">
                        <Btn title="Entrar" shared={shared} color="green" onClick={login} name="send_btn" />
                    </section>
                </section>
            </Box>
            {loading.marker()}
        </section>
    );
};